import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';

/**
 * SSO Guard - Checks for ssostring query parameter and redirects to SSO callback
 * This guard should be applied to routes where SSO login might be initiated
 */
export const ssoGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  // Check if ssostring parameter is present
  const ssostring = route.queryParams['ssostring'];

  if (ssostring) {
    // Redirect to SSO callback component with the ssostring
    router.navigate(['/sso-callback'], {
      queryParams: { ssostring }
    });
    return false;
  }

  // No ssostring, allow normal navigation
  return true;
};
